import { render, staticRenderFns } from "./JpmbSchoolList.vue?vue&type=template&id=c39ed24e&scoped=true&"
import script from "./JpmbSchoolList.vue?vue&type=script&lang=js&"
export * from "./JpmbSchoolList.vue?vue&type=script&lang=js&"
import style0 from "./JpmbSchoolList.vue?vue&type=style&index=0&id=c39ed24e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39ed24e",
  null
  
)

export default component.exports